/*global BMS*/
import {handleGetStateResponse} from '../../../actions/platformActions';
import {clearEventOpenBets} from '../../../actions/eventsActions';
import {toggleCommitBetsError, toggleCommitBetsSuccess, toggleCommittingBets} from '../actions/openBetsActions';
import {isLocalStorageAvailable, isLocalStorageQuotaExceeded} from '../../../helpers/systemHelpers';

let timeOfPlaceBetsNotificationIcon = 5000;

export function createBet(game, event, market, racers = []) {
    let auxGame = {};
    auxGame.channel = game.channel;
    let auxEvent = {};
    auxEvent.channel = event.channel;
    auxEvent.eventId = event.eventId;
    auxEvent.eventTimeDate = event.eventTimeDate;
    auxEvent.eventType = event.eventType;

    return {game: auxGame, event: auxEvent, market, racers, stake: 0};
}

export function getRacingSingleMarket(code, selection, markets) {
    let market;
    if (markets && markets.length) {
        market = markets.find((mkt) => mkt.code === Number(code) && mkt.selection === selection.toString());
    }
    return market;
}

export function marketHasOpenBet(game, event, market, racers = [], openBets) {
    return getOpenBet(game, event, market, racers, openBets)
        ? true
        : false;
}

export function getOpenBet(game, event, market, racers = [], openBets) {
    let openBet = openBets.find((oBet) => oBet.game.channel === game.channel && oBet.event.eventId === event.eventId && oBet.market.id === market.id && compareBetRacers(oBet.racers, racers));
    return openBet;
}

export function compareBetRacers(a, b) {
    if (a && b && a.length === b.length) {
        for (let i = 0; i < a.length; i++) {
            if (a[i].num !== b[i].num) {
                return false;
            }
        }
        return true;
    }
    return false;
}

export function generateForecastPossibilities(racerNumbers) {
    let possibleBets = [];
    if (racerNumbers && racerNumbers.length >= 2) {
        for (let i = 0; i < racerNumbers.length; i++) {
            for (let j = 0; j < racerNumbers.length; j++) {
                if (i === j) {
                    continue;
                }
                possibleBets.push({'first': racerNumbers[i], 'second': racerNumbers[j]});
            }
        }
    }
    return sortForecastPossibilities(possibleBets);
}

export function generateBoxForecastPossibilities(racerNumbers) {
    let possibleBets = [];
    if (racerNumbers && racerNumbers.length >= 2) {
        for (let i = 0; i < racerNumbers.length; i++) {
            for (let j = 0; j < racerNumbers.length; j++) {
                if (i === j || racerNumbers[i] > racerNumbers[j]) {
                    continue;
                }
                possibleBets.push({'first': racerNumbers[i], 'second': racerNumbers[j]});
            }
        }
    }
    return sortForecastPossibilities(possibleBets);
}

export function generateTricastPossibilities(racerNumbers) {
    let possibleBets = [];
    if (racerNumbers && racerNumbers.length >= 3) {
        for (let i = 0; i < racerNumbers.length; i++) {
            for (let j = 0; j < racerNumbers.length; j++) {
                for (let k = 0; k < racerNumbers.length; k++) {
                    if (i === j || i === k || j === k) {
                        continue;
                    }
                    possibleBets.push({'first': racerNumbers[i], 'second': racerNumbers[j], 'third': racerNumbers[k]});
                }
            }
        }
    }
    return sortTricastPossibilities(possibleBets);
}

export function generateBoxTricastPossibilities(racerNumbers) {
    let possibleBets = [];
    if (racerNumbers && racerNumbers.length >= 3) {
        for (let i = 0; i < racerNumbers.length; i++) {
            for (let j = 0; j < racerNumbers.length; j++) {
                for (let k = 0; k < racerNumbers.length; k++) {
                    if (i === j || i === k || j === k || racerNumbers[i] > racerNumbers[j] || racerNumbers[j] > racerNumbers[k]) {
                        continue;
                    }
                    possibleBets.push({'first': racerNumbers[i], 'second': racerNumbers[j], 'third': racerNumbers[k]});
                }
            }
        }
    }
    return sortTricastPossibilities(possibleBets);
}

/* updateLocalOpenBets
 Here a (map)ish object is created here with the corresponding player bets e.g.
   {
    player1: {openBets: [bet1, bet2, bet3, ...]},
    player2: {openBets: [bet1, bet2, ...]},
    player3: {openBets: [bet1, ...]},
    ...
   }
 */
export function updateSimplifiedLocalOpenBets(playerUID, openBetsList = [], openBetsHistory = []) {
    if (!isLocalStorageAvailable) {
        // there is nothing to store if localStorage is not available
        console.warn('Browser local storage disabled, open bets cannot be cached.');
        return;
    }
    let localOpenBets = localStorage.getItem('OPEN_BETS');

    if (localOpenBets === null) {
        localOpenBets = {};
    } else {
        localOpenBets = JSON.parse(localOpenBets);
    }

    // apply the current open bets to the local storage
    localOpenBets[playerUID] = {
        openBetsList,
        openBetsHistory
    };

    try {
        localStorage.setItem('OPEN_BETS', JSON.stringify(localOpenBets));
    } catch (e) {
        if (isLocalStorageQuotaExceeded(e)) { // storage full
            console.warn('Browser local storage is full, open bets cannot be cached.');
        }
    }
}

export function placeAndClearOpenBets(gameChannel, eventId, storeData, dispatch) {
    if (process.env.NODE_ENV !== 'development' && BMS && storeData && storeData.vpp.openBetsList && storeData.vpp.openBetsList.length) {
        let betsToPlace = storeData.vpp.openBetsList.slice().filter((oBet) => oBet.game.channel === gameChannel && oBet.event.eventId === eventId);

        if (betsToPlace.length) {
            placeBets(gameChannel, betsToPlace, dispatch, storeData.vpp.playerUID).then((dispatch) => {
                dispatch(clearEventOpenBets(gameChannel, eventId));
            });
        } else {
            dispatch(clearEventOpenBets(gameChannel, eventId));
        }
    } else {
        // clear EventBets is always performed wether BMS is defined i.e. develop or production environment
        dispatch(clearEventOpenBets(gameChannel, eventId));
    }
}

export function fakePlaceBets(gameChannel, dispatch) {
    dispatch(toggleCommittingBets(gameChannel));
    setTimeout(() => {
        dispatch(toggleCommittingBets(gameChannel));
    }, timeOfPlaceBetsNotificationIcon);

    setTimeout(() => {
        dispatch(toggleCommitBetsSuccess(gameChannel));
    }, timeOfPlaceBetsNotificationIcon);
    setTimeout(() => {
        dispatch(toggleCommitBetsSuccess(gameChannel));
    }, timeOfPlaceBetsNotificationIcon * 2);

    // setTimeout(() => {
    //   dispatch(toggleCommitBetsError(gameChannel));
    // }, timeOfPlaceBetsNotificationIcon);
    // setTimeout(() => {
    //   dispatch(toggleCommitBetsError(gameChannel));
    // }, timeOfPlaceBetsNotificationIcon * 2);
}

let placeBetAlreadyClicked = false;

function placeBets(gameChannel, betsToPlace, dispatch, playerUID) {

    dispatch(toggleCommittingBets(gameChannel));
    return new Promise((resolve, reject) => {
        if (betsToPlace.length) {

            let totalStake = 0;

            for (let i in betsToPlace) {
                let bet = betsToPlace[i];
                let mktId = bet.market.id;
                if (mktId.indexOf('_') === -1) {
                    mktId = mktId.replace('-', '_');
                }
                let channel = Number(bet.game.channel);
                let stake = Number(bet.stake);
                totalStake += stake;
                BMS.api.addBet(channel, bet.event.eventId, mktId, 0, null, null, bet.event.eventTimeDate);
                BMS.api.addSelection(stake);
            }

            BMS.Operator.updateStake(totalStake);

            if (placeBetAlreadyClicked) {
                BMS.Operator.setOverlayAllowed(false);
            } else {
                placeBetAlreadyClicked = true;
            }

            BMS.api.placeBet((response) => placeBetSuccessfull(gameChannel, response, dispatch, playerUID), (error) => {
                BMS.Operator.setOverlayAllowed(true);
                dispatch(toggleCommittingBets(gameChannel));
                dispatch(toggleCommitBetsError(gameChannel));
                setTimeout(() => {
                    dispatch(toggleCommitBetsError(gameChannel));
                }, timeOfPlaceBetsNotificationIcon);
                placeBetError(error, dispatch)
            });
            resolve(dispatch);
        }
    });
}

function placeBetSuccessfull(gameChannel, response, dispatch, playerUID) {
    BMS.Operator.setOverlayAllowed(true);
    dispatch(toggleCommittingBets(gameChannel));
    dispatch(toggleCommitBetsSuccess(gameChannel));
    setTimeout(() => {
        dispatch(toggleCommitBetsSuccess(gameChannel));
    }, timeOfPlaceBetsNotificationIcon);
    dispatch(handleGetStateResponse(response, playerUID, true));
}

export function placeBetError(error, dispatch) {
    // for now all but Insufficient funds errors are threated as internal errors
    switch (error.code) {
        case Number('-30003'):
            // nothing to do here
            error = '-30003';
            break;
        case Number('-20004'):
            // nothing to do here
            error = '-20004';
            break;
        case Number('-32602'):
            // event must be in the future
            error = '-32602';
            break;
        case Number('1000'):
            //The Game was Suspended
            error = '1000';
            break;
        default:
            error = 'INTERNAL_ERROR';
            break;
    }
}

function sortForecastPossibilities(possibilities) {
    return possibilities.sort((a, b) => {
        if (a.first !== b.first) {
            return b.first - a.first;
        } else if (a.second !== b.second) {
            return b.second - a.second;
        } else {
            return 0;
        }
    });
}

function sortTricastPossibilities(possibilities) {
    return possibilities.sort((a, b) => {
        if (a.first !== b.first) {
            return b.first - a.first;
        } else if (a.second !== b.second) {
            return b.second - a.second;
        } else if (a.third !== b.third) {
            return b.third - a.third;
        } else {
            return 0;
        }
    });
}



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/helpers/betHelpers.js